<template>
    <div class="lobby-sidebar">
        <div class="Opend lobby-sidebar-panel">
            <div class="Opend_top">
                <div class="Opend_top_inset">
                    <button v-if="isLogin" type="button" class="lobby-side-profile" @click="openAccount">
                        <AuroraArtIcon name="account" />
                        <span><strong>{{ userPhone }}</strong><small>ID: {{ userInfo.id }}</small></span>
                        <b>VIP {{ userInfo.levelDetailVo && userInfo.levelDetailVo.memberLevelCode || 0 }}</b>
                    </button>
                    <div v-else class="login-wrap lobby-side-login"><button type="button" class="sign_up" @click="toLogin(1)">{{ $t('login.SignUp') }}</button><button type="button" class="login_btn" @click="toLogin(2)">{{ $t('login.SignIn') }}</button></div>
                    <section class="lobby-side-wallet">
                        <div class="lobby-side-balance"><span>{{ $t('person.Balance') }}</span><button v-if="isLogin" type="button" :aria-label="$t('person.Balance')" @click="getUserInfo"><AuroraIcon name="refresh" :class="{ turning: isRefreshingMoney }" /></button></div>
                        <strong @click="isLogin && $store.dispatch('user/setIsShowBalancePopup', true)">{{ isLogin ? CurrencyType + allBalance : '—' }}</strong>
                        <div class="lobby-side-funds"><button type="button" @click="openWallet('deposit')">+ {{ $t('deposit.Deposit') }}</button><button type="button" @click="openWallet('Withdraw')">{{ $t('Withdraw.Withdraw') }} <AuroraIcon name="chevron" /></button></div>
                        <button type="button" class="lobby-side-invite" @click="onMenuItem('Affiliate')"><AuroraArtIcon name="users" /><span>{{ $t('person.InvitationCenter') }}</span><AuroraIcon name="chevron" /></button>
                    </section>
                    <language class="lobby-side-language" :show="true" :showIcon="true">
                        <template #langType><span class="lobby-language-label"><span>{{ langName }}</span><AuroraIcon v-if="DisabledBelongCountry !== 'disable'" name="chevron" /></span></template>
                    </language>
                    <div v-if="showThemeSkinSelect" class="sidebar-theme-select">
                        <select v-model="themeSkin" aria-label="Theme" @change="onThemeSkinChange"><option v-for="item in themeSkinOptions" :key="item.value" :value="item.value">{{ item.label }}</option></select>
                    </div>
                    <nav class="lobby-side-group" :aria-label="$t('tabbar.Lobby')">
                        <h2>{{ $t('tabbar.Lobby') }}</h2>
                        <button v-if="isShowSport" type="button" class="lobby-side-link" :class="{ act: pathAct === 'Sports' }" @click="toSports"><img class="sidebar-sport-icon" src="@/assets/common/zuqiu.png" alt="" /><span>{{ $t('sports.title') }}</span><AuroraIcon name="chevron" /></button>
                        <button v-for="item in gameLinks" :key="item.key" type="button" class="lobby-side-link" :class="{ act: pathAct === item.route && !item.category }" @click="openGameLink(item)"><AuroraArtIcon :name="item.icon" /><span>{{ $t(item.label) }}</span><AuroraIcon name="chevron" /></button>
                    </nav>
                    <nav class="lobby-side-group" :aria-label="$t('person.Promotion')">
                        <h2>{{ $t('person.Promotion') }}</h2>
                        <button type="button" class="lobby-side-link" :class="{ act: pathAct === 'Event' }" @click="onMenuItem('Event')"><AuroraArtIcon name="gift" /><span>{{ $t('person.Promotion') }}</span><AuroraIcon name="chevron" /></button>
                        <button type="button" class="lobby-side-link lobby-side-redemption" @click="openRedemptionCode"><AuroraArtIcon name="ticket" /><span>{{ $t('RedemptionCode.RedemptionCode') }}</span><AuroraIcon name="chevron" /></button>
                        <button v-for="(item, index) in sidebarActivities" :key="item.id || item.eventType + index" type="button" class="lobby-side-link lobby-side-event" :data-event-type="item.eventType" :data-event-id="item.id" @click="toItem(item)"><AuroraArtIcon :name="sidebarEventIcon(item)" /><span>{{ item.eventName }}</span><AuroraIcon name="chevron" /></button>
                        <button type="button" class="lobby-side-link lobby-side-service" @click="toItem({ eventType: 'customerServiceTelegram' })"><AuroraArtIcon name="headset" /><span>{{ $t('person.LiveChat') }}</span><AuroraIcon name="chevron" /></button>
                    </nav>
                </div>
            </div>
            <div v-if="isLogin" class="lobby-side-footer">
                <button type="button" class="lobby-side-link lobby-side-logout" @click="$refs.logoutPopup.open()"><AuroraIcon name="logout" /><span>{{ $t('logout.SignOut') }}</span></button>
            </div>
        </div>
        <button type="button" class="Sidebar-close-icon" :aria-label="$t('lang.cancel')" @click="handleClickOutside"><AuroraIcon name="close" /></button>
        <logoutPopup ref="logoutPopup" />
    </div>
</template>

<script>
import { mapState } from 'vuex'
import AuroraIcon from '@/components/auroraIcon'
import AuroraArtIcon from '@/components/auroraIcon/artIcon.vue'
import { eventIcons } from '@/components/auroraIcon/icons'
import { getHomeActivities } from '@/utils/homeActivities'
import language from '@/components/language'
import logoutPopup from '@/components/logoutPopup'
import { getEventsHomeShow } from '@/api/home'
import { getCustomEventInfo } from '@/api/event'
import { Toast } from 'vant'
import handleCopy from '@/utils/copy.js'
import { domainKey, defaultThemeSkin, showThemeSkinSelect, themeSkinOptions } from '@/common/http'
import { getUserInfo } from '@/api/user'
export default {
    name: 'Sidebar',
    components: { AuroraIcon, AuroraArtIcon, language, logoutPopup },
    data() {
        return {
            domainKey,
            themeSkin: defaultThemeSkin,
            showThemeSkinSelect,
            themeSkinOptions,
            activeList: [],
            activeEventId: '',
            gameLinks: [
                { key: 'home', route: 'Home', icon: 'home', label: 'home.Popular' },
                { key: 'slots', route: 'Home', category: 'Slot', icon: 'slots', label: 'tabbar.Lobby' },
                { key: 'providers', route: 'Providers', icon: 'menu', label: 'home.Providers' },
                { key: 'recent', route: 'Home', category: 'Recent', icon: 'clock', label: 'home.Recent' },
                { key: 'favorites', route: 'Home', category: 'Favoritos', icon: 'heart', label: 'home.Favorite' }
            ],
            act: 0,
            hoverAct: 0,
            hoverActTemp: 0,
            isHover: false,
            subAct: 0,
            isShowSub: false,
            PCSubMenus: [],
            pathAct: '',
            platforms: [],
            showPlatformsPopover: false,
            isRefreshingMoney: false
        }
    },
    computed: {
        sidebarActivities() {
            return this.activeList
        },
        ...mapState({
            sidebar: state => state.app.sidebar,
            device: state => state.app.device
        }),
        mobile() {
            return this.device === 'mobile'
        },
        isLogin() {
            return !!this.$store.getters.token
        },
        sysConfig() {
            return this.$store.getters.sysConfig
        },
        isCollapse() {
            return !this.sidebar.opened
        },
        userInfo() {
            return this.$store.getters.userInfo
        },
        userPhone() {
            const phone = this.userInfo && this.userInfo.phone
            return phone ? this.maskNumber(phone) : ''
        },
        langName() {
            const type = this.$store.getters.language
            return this.langObj[type]?.name || type
        },
        isShowSport() {
            if (this.$store.getters.userInfo?.memberType === 'virtually') return false
            const msg = this.$store.state.system.betSportMsg
            return !!(msg && msg.brandId != null && msg.brandId !== '' && msg.gameInfoId != null && msg.gameInfoId !== '')
        }
    },
    watch: {
        $route: {
            handler: function (to, from) {
                this.act = ''
                this.subAct = ''
                const opt = this.$route?.params
                if (opt && opt.params) {
                    const params = JSON.parse(decodeURIComponent(opt?.params))
                    this.act = params?.code
                    if (params.gameTitleId) this.subAct = params.gameTitleId
                }
                this.pathAct = this.$route.name
            },
            deep: true
        },
        sysConfig: {
            handler: function (newVal, oldVal) {
                if (newVal) {
                    this.GetPlatforms()
                }
            },
            deep: true,
            immediate: true
        }
    },
    created() {
        this.getActiveInfo()
        this.act = ''
        this.subAct = ''
        const opt = this.$route?.params
        if (opt && opt.params) {
            const params = JSON.parse(decodeURIComponent(opt?.params))
            this.act = params?.code
            if (params.gameTitleId) this.subAct = params.gameTitleId
        }
        this.pathAct = this.$route.name
    },
    methods: {
        openRedemptionCode() {
            this.handleClickOutside()
            this.$emit('open-redemption-code')
        },
        onThemeSkinChange() {
            window.localStorage.setItem('themeSkin', this.themeSkin)
            Toast('当前分支皮肤为打包时主题，切换后请重启服务或重新打包查看。')
        },
        sidebarEventIcon(item) {
            return eventIcons[item.eventType] || 'gift'
        },
        openWallet(type) {
            this.handleClickOutside()
            this.onNavTo({ url: '/wallet', type: 'get', params: { type } })
        },
        openAccount() {
            this.handleClickOutside()
            if (this.mobile) this.onNavToByIsLogin({ url: '/Person' })
            else if (this.isLogin) this.$store.dispatch('user/setIsShowMyPopup', true)
            else this.toLogin(2)
        },
        openGameLink(item) {
            this.handleClickOutside()
            if (this.$route.name === 'Home' && item.route === 'Home') {
                this.$root.$emit('home:category', item.category || 'Popular')
                return
            }
            this.onNavTo({ url: '/' + item.route, type: 'get', params: item.category ? { category: item.category } : {} })
        },
        getUserInfo() {
            this.isRefreshingMoney = true
            getUserInfo().finally(() => {
                this.isRefreshingMoney = false
            })
        },
        onMenuItem(act, isLogin) {
            this.handleClickOutside()
            if (this.$route.name === act) return
            if (isLogin) {
                this.onNavToByIsLogin({ url: act, type: 'post' })
            } else {
                this.onNavTo({ url: act, type: 'post' })
            }
        },
        enterMenuItem(item) {
            if (item !== 'sub') {
                this.PCSubMenus = item
                this.hoverAct = item.id
                this.hoverActTemp = item.id
            } else {
                this.hoverAct = this.hoverActTemp
            }
            if (!this.mobile) this.isHover = true
        },
        leaveMenuItem(item) {
            this.hoverAct = ''
            if (!this.mobile) this.isHover = false
        },
        getActiveInfo() {
            getEventsHomeShow().then((res) => {
                if (!res) return
                if (res.code) return
                const D = res.result || {}
                this.activeList = getHomeActivities(D)
                if (Array.isArray(D.eventPopupList) && D.eventPopupList.length) {
                    D.eventPopupList.forEach(x => {
                        if (x.eventType === 'registerRewards') {
                            this.$store.dispatch('user/setEventRegisterReward', x.eventRewardDescription)
                        }
                    })
                }
            })
        },
        toBonusRainPopup() {
            this.$store.dispatch('user/setIsShowRedPacketPopup', { show: true })
        },
        handleClickOutside() {
            this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
        },
        maskNumber(phoneNumber) {
            const str = phoneNumber.toString()
            if (str.length <= 4) {
                return str
            }
            const firstTwo = str.slice(0, 2)
            const lastTwo = str.slice(-2)
            return `${firstTwo}***${lastTwo}`
        },
        copyText(content) {
            handleCopy(
                {
                    content,
                    success: (msg) => {
                        Toast(msg)
                    },
                    error: (msg) => {
                        Toast(msg)
                    }
                },
                this
            )
        },
        toLogin(type) {
            if (this.isLogin) {
                this.$store.dispatch('user/setIsShowMyProfilePopup', true)
            } else {
                this.$store.dispatch('user/changeLoginType', type)
                this.$store.dispatch('user/setIsShowLoginPopup', true)
            }
        },
        GetPlatforms() {
            this.platforms = []
            const systemConfig = this.sysConfig
            // const facebook = systemConfig.facebook?.trim()
            // if (facebook) {
            //     const platform1 = {
            //         id: 0,
            //         icon: require('@/assets/share/icon_fackbook.png'),
            //         title: 'Facebook',
            //         url: facebook,
            //         linkType: 'href'
            //     }
            //     this.platforms.push(platform1)
            // }
            // const telegram = systemConfig.telegram?.trim()
            // if (telegram) {
            //     const platform2 = {
            //         id: 1,
            //         icon: require('@/assets/share/icon_telegram.png'),
            //         title: 'Telegram',
            //         url: telegram,
            //         linkType: 'href'
            //     }
            //     this.platforms.push(platform2)
            // }
            const telegramGroup = systemConfig.telegramGroup?.trim()
            if (telegramGroup) {
                const platform8 = {
                    id: 1,
                    icon: require('@/assets/share/icon_telegram.png'),
                    title: 'Telegram',
                    url: telegramGroup,
                    linkType: 'href'
                }
                this.platforms.push(platform8)
            }
            const instagram = systemConfig.instagram?.trim()
            if (instagram) {
                const platform3 = {
                    id: 2,
                    icon: require('@/assets/share/icon_ins.png'),
                    title: 'Instagram',
                    url: instagram,
                    linkType: 'href'
                }
                this.platforms.push(platform3)
            }
            // const youTube = systemConfig.youTube?.trim()
            // if (youTube) {
            //     const platform4 = {
            //         id: 3,
            //         icon: require('@/assets/share/icon_youtube.png'),
            //         title: 'Youtube',
            //         url: youTube,
            //         linkType: 'href'
            //     }
            //     this.platforms.push(platform4)
            // }
            const whatsapp = systemConfig.whatsapp?.trim()
            if (whatsapp) {
                const platform5 = {
                    id: 4,
                    icon: require('@/assets/share/icon_whatsapp.png'),
                    title: 'Whatsapp',
                    url: whatsapp,
                    linkType: 'href'
                }
                this.platforms.push(platform5)
            }
            // const twitter = systemConfig.twitter?.trim()
            // if (twitter) {
            //     const platform6 = {
            //         id: 5,
            //         icon: require('@/assets/share/icon_x.png'),
            //         title: 'X',
            //         url: twitter,
            //         linkType: 'href'
            //     }
            //     this.platforms.push(platform6)
            // }
            // const tiktok = systemConfig.tiktok?.trim()
            // if (tiktok) {
            //     const platform7 = {
            //         id: 6,
            //         icon: require('@/assets/share/icon_tiktok.png'),
            //         title: 'TikTok',
            //         url: tiktok,
            //         linkType: 'href'
            //     }
            //     this.platforms.push(platform7)
            // }
        },
        toSearch() {
            this.$store.dispatch('user/setIsShowSearchPopup', true)
        },
        toItem(item) {
            this.handleClickOutside()
            this.activeEventId = item.id || item.eventType
            // console.log(item)
            if (item.eventType === 'reliefMoney') {
                // this.$store.dispatch('user/setIsShowLossSupportPopup', { id: item.id, show: true })
                this.onNavTo({ url: 'WeeklyRescue', params: { id: item.id } })
            }
            if (item.eventType === 'signIn') {
                this.$store.dispatch('user/setIsShowCheckInPopup', { id: item.id, show: true })
                // this.onNavTo({ url: 'SignIn', type: 'post' })
            }
            if (item.eventType === 'vipSignIn') {
                this.onNavToByIsLogin({ url: 'SignIn', params: { id: item.id } })
            }
            if (item.eventType === 'luckyWheel') {
                const params = { id: item.id }
                this.onNavTo({ url: 'Turntable', params })
            }
            if (item.eventType === 'custom') {
                getCustomEventInfo({ id: item.id }).then((res) => {
                    if (res.code) return
                    const D = res.result
                    if (D.displayMode === 'BuiltInPage') {
                        const obj = { id: D.id, eventName: D.eventName, createTime: D.createTime, eventContent: D.eventContent }
                        const params = encodeURIComponent(JSON.stringify(obj))
                        const timestamp = new Date().getTime()
                        this.onNavTo({ url: 'PromotionCustom', type: 'post', params: { timestamp, params } })
                    }
                    if (D.displayMode === 'JumpOutside') {
                        console.log(D.appSkipMode)
                        if (D.appSkipMode === 'newWindowOpen') {
                            const url = D.appHref
                            const type = 'href'
                            this.onNavTo({ url, type })
                        }
                        if (D.appSkipMode === 'nowPageOpen') {
                            // const encodedUrl = encodeURIComponent(D.appHref)
                            // const finalUrl = '/pages/webview/deposit_wv?url=' + encodedUrl
                            // this.onNavTo(finalUrl)
                        }
                        if (D.appSkipMode === 'builtInPageOpen') {
                            const url = D.appHref
                            this.onNavToByIsLogin({ url })
                        }
                    }
                })
            }
            if (item.eventType === 'redPacket') {
                this.$store.dispatch('user/setIsShowRedPacketPopup', { id: item.id, show: true })
            }
            if (item.eventType === 'extend') {
                this.onNavToByIsLogin({}).then(() => {
                    this.$store.dispatch('user/setIsShowTreasureChestPopup', { id: item.id, show: true })
                })
            }
            if (item.eventType === 'gameBetting') {
                this.$store.dispatch('user/setIsShowRebatePopup', { id: item.id, show: true })
            }
            if (item.eventType === 'rechargeRewards') {
                this.onNavTo({ url: '/Affiliate' })
            }
            if (item.eventType === 'gameBettingRewards') {
                this.onNavTo({ url: '/Affiliate' })
            }
            if (item.eventType === 'pinduoduo') {
                this.onNavToByIsLogin({ url: 'Pinduoduo', params: { id: item.id } })
            }
            if (item.eventType === 'rankingList') {
                this.$store.dispatch('user/setIsShowWinRankListPopup', { id: item.id, show: true })
            }
            if (item.eventType === 'registerRewards') {
                const obj = { type: item.eventType }
                const params = encodeURIComponent(JSON.stringify(obj))
                const timestamp = new Date().getTime()
                this.onNavTo({ url: 'PromotionCustom', type: 'post', params: { timestamp, params } })
            }
            if (item.eventType === 'customerServiceTelegram') {
                this.onNavTo({ url: this.sysConfig.telegram, type: 'href' })
            }
            if (item.eventType === 'customerPending') {
                this.$store.dispatch('user/setIsShowPendingPopup', true)
            }
            if (item.eventType === 'totalRecharge') {
                this.$store.dispatch('user/setIsShowDepositTotalPopup', { id: item.id, show: true })
            }
            if (item.eventType === 'rechargeGift') {
                this.$store.dispatch('user/setIsShowDepositRepeatPopup', { id: item.id, show: true })
            }
            if (item.eventType === 'usdtRechargeGift') {
                this.$store.dispatch('user/setIsShowDepositRepeatUsdtPopup', { id: item.id, show: true })
            }
            if (item.eventType === 'VIP') {
                this.onNavToByIsLogin({ url: 'vip' })
            }
        },
        toSports() {
            this.handleClickOutside()
            if (this.$route.name === 'Sports') return
            this.onNavTo({ url: '/Sports' })
        }
    }
}
</script>

<style lang="scss" scoped>
.sidebar-sport-icon {
    width: .44rem;
    height: .44rem;
    object-fit: contain;
    flex-shrink: 0;
}
@import '@/common/styles/viriables.scss';

.Sidebar-close-icon {
    position: absolute;
    background: var(--aurora-surface);
    width: .68rem;
    height: .68rem;
    top: .38rem;
    right: -.88rem;
    border-radius: 50%;
    align-items: center;
    justify-content: center;
    font-size: .34rem;
    display: none;
    cursor: pointer;

    svg {
        fill: var(--aurora-ink);
    }
}

.Opend {
    display: block;
    height: 100%;
    box-sizing: border-box;
    // padding: 18px 10px;
    // padding-top: 10px;
    padding-right: 0;
    overflow: auto;
    width: 300px;
    // background-color: #17191f;
    // box-shadow: 8px 0 8px #00000040;
    // transition-duration: 0.3s;
    position: relative;
    z-index: 2;
    scrollbar-width: none;
    display: flex;
    flex-direction: column;

    &::-webkit-scrollbar {
        display: none;
        /* 对于 Chrome, Safari 和 Opera 隐藏滚动条 */
    }
}

.Opend_top {
    flex: 1;
    width: 100%;
    position: relative;

    .Opend_top_inset {

        &::-webkit-scrollbar {
            display: none;
            /* 对于 Chrome, Safari 和 Opera 隐藏滚动条 */
        }

        .flex {
            display: flex;
            align-items: center;
            justify-content: space-between;
        }

        .flex-start {
            display: flex;
            align-items: center;
            justify-content: flex-start;
        }

        .user_info {
            width: 100%;
            height: 1.8rem;
            margin: 0rem auto .3rem;
            justify-content: center;
            border-radius: .3rem;
            padding: .2rem .3rem;
            position: relative;
            background:
                var(--aurora-soft-gradient) !important;
            border: 1px solid var(--aurora-line) !important;
            box-shadow: inset 0 1px 0 var(--aurora-shadow-color), 0 .08rem .18rem var(--aurora-shadow-color) !important;
            overflow: visible;

            .current-level-wrap {
                position: absolute;
                left: 0;
                top: -.1rem;
                padding: .05rem .2rem;
                border-radius: .3rem 0;
                background:
                    var(--aurora-soft-gradient) !important;
                box-shadow: inset 0 1px 0 var(--aurora-shadow-color), 0 .06rem .14rem var(--aurora-shadow-color) !important;
                color: var(--aurora-ink) !important;
                fill: var(--aurora-ink) !important;

                svg {
                    width: .3rem;
                    height: .3rem;
                    margin-right: .05rem;
                    fill: currentColor;
                    color: var(--aurora-ink) !important;
                    fill: var(--aurora-ink) !important;
                }

                p {
                    font-size: .22rem;
                    line-height: .22rem;
                    font-style: italic;
                    font-weight: 700;
                    text-shadow: 0 1px 1px var(--aurora-shadow-color);
                    margin: 0;
                    color: var(--aurora-ink) !important;
                }
            }

            .user-info {
                flex: 0 1 100%;
                text-align: left;
                margin-left: .1rem;

                .user-name {
                    font-size: .3rem;
                    font-weight: 500;
                    padding-right: .15rem;
                    margin-right: .15rem;
                    margin-bottom: .1rem;
                    color: var(--aurora-ink) !important;
                }

                .user-code {
                    p {
                        color: var(--aurora-ink) !important;
                        opacity: .8;
                        font-weight: 500;
                        margin: 0;
                    }

                    svg {
                        width: .3rem;
                        height: .3rem;
                        margin-left: .1rem;
                        fill: currentColor;
                        color: var(--aurora-ink) !important;
                    }
                }
            }

            .avatar-wrap {
                display: flex;
                justify-content: center;
                align-items: center;
                position: relative;

                .avatar {
                    width: 1.4rem;
                    height: 1.4rem;
                    border: .04rem solid var(--aurora-line);
                    border-radius: 100px;
                    overflow: hidden;

                    img {
                        width: 100%;
                        height: 100%;
                        pointer-events: none;
                        vertical-align: bottom;
                    }
                }
            }
        }

        .login-wrap {
            width: 100%;
            position: relative;
            display: flex;
            justify-content: space-between;
            margin: .3rem auto .4rem;

            &>div {
                width: 2rem;
                flex: 0 1 49%;
                height: .8rem;
                border-radius: .16rem;
                padding: 0 .1rem;
                font-size: .28rem;
                display: flex;
                align-items: center;
                justify-content: center;

                &.sign_up {
                    background: var(--aurora-primary-gradient);
                    border-color: var(--aurora-line);
                    margin-right: .15rem;
                }

                &.login_btn {
                    background: none;
                    border: 1px solid var(--aurora-line);
                    color: var(--aurora-on-primary);
                }
            }
        }
    }
}

.Opend_bottom {
    // width: 100%;
    position: relative;
    background: var(--aurora-soft-gradient);
    border: 1px solid var(--aurora-line);
    box-shadow: inset 0 1px 6px var(--aurora-shadow-color);
    border-radius: 18px;
    margin: 4px 12px 10px;
    padding: 20px 10px;

    &>.sidebar_line {
        width: 100%;
        height: 0px;
        border-top: 1px dashed var(--aurora-line);
        transform: scaleY(.5);
        margin: 19px auto;
    }

    .sidebar_icons_lang {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .sidebar_icons {
            display: flex;
            align-items: center;

            &>img {
                cursor: pointer;
                width: 40px;
                height: 40px;
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: 20px;
                color: var(--aurora-ink);
                cursor: pointer;
                font-size: 16px;
                margin-right: 6px;
            }

            .sidebar_icons_more {
                width: .6rem;
                height: .6rem;
                background: var(--aurora-surface);
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: .2rem;
                cursor: pointer;

                svg {
                    fill: var(--aurora-muted);
                }
            }
        }
    }

    .sidebar_customerService {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 45px;
        border-radius: 10px;
        font-size: 16px;
        font-weight: 600;
        background:
            var(--aurora-primary-gradient);
        border: 1px solid var(--aurora-line);
        box-shadow:
            inset 0 1px 0 var(--aurora-shadow-color),
            0 0 .2rem var(--aurora-shadow-color),
            0 .08rem .18rem var(--aurora-shadow-color);
        color: var(--aurora-on-primary);
    }

    .sidebar_lang {
        display: flex;
        align-items: center;
        background:
            var(--aurora-soft-gradient);
        border-color: var(--aurora-line);
        box-shadow:
            inset 0 1px 0 var(--aurora-shadow-color),
            0 0 .14rem var(--aurora-shadow-color);
        height: 40px;
        padding: 4px 8px;
        padding-right: 8px;
        width: 136px;
        border-radius: 7px;
        cursor: pointer;

        .sidebar_lang_box {
            display: flex;
            align-items: center;
            justify-content: center;

            .sidebar_lang_txt {
                margin: 0 .08rem;
                color: var(--aurora-ink);
                font-weight: bold;
                font-size: .25rem;
            }

            svg {
                fill: var(--aurora-ink);
                font-weight: bold;
            }
        }
    }
}

.share_box {
    height: 72px;
    margin: 20px 11px 15px;
    padding: 16px 10px;
    background:
        var(--aurora-soft-gradient);
    border: 1px solid var(--aurora-line);
    box-shadow: inset 0 1px 0 var(--aurora-shadow-color), 0 .1rem .22rem var(--aurora-shadow-color);
    border-radius: 12px;
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 700;
    cursor: pointer;
    line-height: normal;
    position: relative;

    &>div {
        width: 2.5rem;
        display: block;
        margin-left: 10px;
        position: relative;
        z-index: 1;
        text-align: left;
        color: var(--aurora-ink);
        text-shadow: 0 .02rem .06rem var(--aurora-shadow-color);
    }

    &>img {
        position: absolute;
        bottom: -18px;
        right: -3px;
        width: 124px;
        height: 124px;
    }
}

.userMoneyItem {
    position: relative;
    margin: 12px 11px;
    padding: 12px 10px;
    margin-bottom: 16px;
    background:
        var(--aurora-soft-gradient);
    border: 1px solid var(--aurora-line);
    box-shadow: inset 0 1px 0 var(--aurora-shadow-color), 0 .1rem .22rem var(--aurora-shadow-color);
    border-radius: 12px;
    font-weight: bold;

    .userMoneyInfo {
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: var(--aurora-muted);

        .align-center {
            align-items: center !important;
        }

        .d-flex {
            display: flex !important;
        }

        .userMoneyAdd {
            width: 95px;
            height: 40px;
            background:
                var(--aurora-primary-gradient);
            border: 1px solid var(--aurora-line);
            box-shadow: inset 0 1px 0 var(--aurora-shadow-color), 0 0 .18rem var(--aurora-shadow-color);
            border-radius: 10px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            font-size: 14px;
            font-weight: 600;
            margin-left: 10px;
            text-transform: capitalize;
            color: var(--aurora-on-primary);
        }

        .userRefrash {
            width: 30px;
            height: 30px;
            cursor: pointer;
            margin-right: 10px;
            background:
                var(--aurora-soft-gradient);
            border: 1px solid var(--aurora-line);
            box-shadow: inset 0 1px 0 var(--aurora-shadow-color);
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 8px;

            img {
                width: 18px;
                height: 18px;

                &.turning {
                    animation: rotateAni 0.2s linear infinite;
                }

                @keyframes rotateAni {
                    0% {
                        transform: rotate(0deg);
                    }

                    100% {
                        transform: rotate(-360deg);
                    }
                }
            }
        }

        .moneyInfo {
            flex: 1;
            font-size: 16px;
            color: var(--aurora-ink);
        }
    }
}

.search_btn {
    width: 100%;
    border-radius: .14rem;
    background: var(--aurora-surface);
    border: 1px solid var(--aurora-line);
    margin-bottom: .25rem;
    padding: .15rem .3rem;
    box-shadow: 0 -1px 10px var(--aurora-shadow-color) inset;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;

    .txt {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: .26rem;
        color: var(--aurora-muted);
    }

    .iconfont {
        color: var(--aurora-muted);
        font-weight: bold;
    }
}

.event_list {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-between;
    // gap: .16rem;
    margin-bottom: 4px;
    padding: 0 12px;

    .event_item {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        background: var(--aurora-surface);
        border: 1px solid var(--aurora-line);
        box-shadow: inset 0 1px 6px var(--aurora-shadow-color);
        border-radius: .15rem;
        cursor: pointer;
        height: 1.18rem;
        border-radius: .2rem;
        flex: 1 1 calc(25% - .08rem);
        min-width: 0;
        padding: .13rem .05rem .08rem;
        justify-content: flex-start;
        position: relative;
        overflow: hidden;

        &.W33P {
            width: calc(33.333333% - .18rem);
        }

        &.W25P {
            width: calc(25% - .07rem);
        }

        &>img {
            height: 45px;
            width: 45px;
            vertical-align: middle;
            margin-top: -8px;
        }

        &>div {
            color: var(--aurora-ink);
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            width: 100%;
            padding: 0 .08rem;
            font-size: 12px;
        }

        &:hover {
            background: var(--aurora-lilac) !important;
        }

        &.act {
            background: var(--aurora-lilac) !important;
        }
    }
}

.sidebar_line {
    height: .01rem;
    margin: 0 auto;
    background: var(--aurora-surface);
    margin-right: .19rem;
}

.menu-group {
    background-color: transparent !important;
    padding: 12px 12px !important;
}

.menu-item {
    width: 100%;
    height: 52px;
    display: flex;
    align-items: center;
    font-size: 15px;
    font-weight: 600;
    position: relative;
    cursor: pointer;
    border-radius: 10px;
    margin-bottom: 10px;
    font-weight: bold;
    background:
        var(--aurora-soft-gradient);
    border: 1px solid var(--aurora-line);
    box-shadow:
        inset 0 1px 0 var(--aurora-shadow-color),
        0 .05rem .12rem var(--aurora-shadow-color);
    color: var(--aurora-ink);

    .icon_hot {
        object-fit: contain;
        width: 22px;
        height: 22px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 14px;
        vertical-align: middle;
    }

    .upto-rate-wrap {
        position: absolute;
        top: -7px;
        right: -10px;
        // border-radius: 4px;
        color: var(--aurora-ink);
        animation: uptoAni 1s infinite ease-in-out;
        background: url(@/assets/sidebar/hot1-Byk-tGIM.png) no-repeat center / 100%;
        width: 66px;
        height: 19px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    @keyframes uptoAni {
        0% {
            transform: scale(1)
        }

        50% {
            transform: scale(1.04, 1.1)
        }

        to {
            transform: scale(1)
        }
    }

    .icon {
        // margin-right: 6px;

        ::v-deep .van-icon {
            font-size: .5rem;
            font-weight: 400;
            margin: 0 .2rem;
            vertical-align: middle;
            color: var(--aurora-accent);
        }
    }

    &.act,
    &:hover {
        background:
            var(--aurora-lilac);
        border-color: var(--aurora-accent);
        color: var(--aurora-accent);
        box-shadow:
            inset 0 1px 0 var(--aurora-shadow-color),
            0 0 .2rem var(--aurora-shadow-color),
            0 .05rem .12rem var(--aurora-shadow-color);
    }
}

.Opend {
    background:
        var(--aurora-soft-gradient);
}

.Sidebar-close-icon {
    background: var(--aurora-soft-gradient);

    svg {
        fill: var(--aurora-ink);
    }
}

.login-wrap>div.login_btn {
    border: 1px solid var(--aurora-line);
    color: var(--aurora-on-primary);
    background: var(--aurora-primary-gradient);
}

.event_list {
    padding: 0 .12rem;
    gap: .1rem;
    margin-bottom: .16rem;
}

.Opend {
    background:
        var(--aurora-soft-gradient);
}

.Opend {
    background:
        var(--aurora-soft-gradient);
}
</style>
